import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection = ({ title, subtitle, showButtons = true }) => {
  return (
    <section className="zoho-hero">
      <div className="zoho-hero-container">

        <div className="zoho-hero-content">
          <h1 className="zoho-hero-title">{title}</h1>

          <p className="zoho-hero-subtitle">
            {subtitle}
          </p>

          {showButtons && (
            <div className="zoho-hero-actions">
              <Link to="/services" className="zoho-btn zoho-btn-primary">
                Explore Our Services
              </Link>

              <Link to="/contact" className="zoho-btn zoho-btn-outline">
                Book Free Consultation
              </Link>
            </div>
          )}
        </div>

      </div>
    </section>
  );
};

export default HeroSection;
